<template>
    <div class="dtp-container mm-datepicker" v-show="showModal">
        <div class="dtp" @click.prevent="showModal = false"></div>
        <div class="dtp-content mmDatepicker" >
            <div class="dtp-header text-center">
                <span>{{nameDay}}</span>
                <a href="#" @click.prevent="showModal = false">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                </a>
            </div>
            <div class="dtp-date text-center">
                <a href="#" @click.prevent="navigateMonth(-1)">
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="15 18 9 12 15 6"></polyline></svg>
                </a>
                <div><b>{{day}}</b></div>
                <div class="text-uppercase">{{monthName}}</div>
                <div>{{year}}</div>
                <a href="#" @click.prevent="navigateMonth(1)">
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="9 18 15 12 9 6"></polyline></svg>
                </a>
            </div>
            <b-calendar v-model="fecha" hide-header start-weekday="1" @selected="selectDay" @context="onContext"></b-calendar>
        </div>
    </div>
</template>

<script>
    import { BCalendar } from 'bootstrap-vue'
    import moment from 'moment'
    export default {
        name: 'mmDatepicker',
        components: {
            BCalendar
        },
        data() {
            return {
                fecha: '',
                day: 0,
                year: 0,
                nameDay: '',
                monthName: '',
                showModal: false,
                callback: false
            }
        },
        methods: {
            navigateMonth(value) {
                let f = moment(this.fecha, 'YYYY-MM-DD', true);
                this.fecha = f.add(value, 'months').format('YYYY-MM-DD');
            },
            onContext(ctx) {
                this.monthName = document.getElementsByClassName('b-calendar-grid-caption')[0].innerText
                this.nameDay = ctx.activeFormatted.split(',')[0];
                let f = moment(ctx.selectedYMD, 'YYYY-MM-DD', true);
                this.day = f.format('DD');
                this.year = f.format('YYYY');
                this.monthName = f.lang('es').format('MMMM').substring(0, 3);
            },
            openModal(value, funcCallback) {
                let f = moment(value, 'DD/MM/YYYY', true);
                this.fecha = f.isValid() ? f.format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
                this.showModal = true;
                this.callback = funcCallback;
            },
            selectDay(value) {
                this.showModal = false;
                let fecha = moment(value, 'YYYY-MM-DD', true);
                
                this.$emit('input', fecha.format('DD/MM/YYYY'));
                if(this.callback != undefined) this.callback(fecha.format('DD/MM/YYYY'));
            }
        }
    }
</script>

<style>
.dtp-container, .dtp {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}
.dtp-container {
    z-index: 2000;
}
.dtp {
    background: rgba(0,0,0,.4);
    font-size: 15px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.dtp-content {
    background: #fff;
    max-width: 300px;
    box-shadow: 0 2px 5px 0 rgba(0,0,0,.16), 0 2px 10px 0 rgba(0,0,0,.12);
    max-height: 520px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.dtp-header {
    background-color: #0062ae!important;
    color: #fff;
    padding: 5px;
    position: relative;
}
.dtp-header a {
    position: absolute;
    right: 10px;
    color: #fff;
}
.dtp-date {
    background-color: #3196e2;
    color: #fff;
    font-size: 25px;
    padding: 15px 10px;
    line-height: 30px;
    position: relative;
}
.dtp-date b {
    font-size: 36px;
}
.dtp-date a {
    position: absolute;
    color: #fff;
    font-size: 44px;
    top: 50%;
    transform: translateY(-50%);
    right: 5px;
}
.dtp-date a:first-child {
    right: initial;
    left: 5px;
}
.mm-datepicker .b-calendar-nav, .mmDatepicker footer {
    display: none!important;
}
.mm-datepicker .b-calendar-grid-caption {
    padding: 22px;
}
.mm-datepicker .b-calendar-grid-help {
    display: none;
}
</style>